// Blog slider 
// if (window.matchMedia("(max-width: 767px)").matches) {
  $('.Blog_Slider .custom_blog_grid').slick({
    infinite: true,
    slidesToShow:3,
    slidesToScroll:1,
    arrow:true,
    centerMode: true,
    centerPadding: '0px',
    prevArrow:"<img class='a-left control-c customprev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay.svg?v=1722836043'>",
    nextArrow:"<img class='a-right control-c next customnext slick-next' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay_3x_f12c4bcc-a795-4d8c-b7da-0cc091b453ad.svg?v=1722836042'>",
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });
// }


if (window.matchMedia("(max-width: 767px)").matches) {
    $('.Adeqo_Slider .Adiqo').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll:1,
        arrow:true,
        prevArrow:"<img class='a-left control-c customprev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay.svg?v=1722836043'>",
        nextArrow:"<img class='a-right control-c next customnext slick-next' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay_3x_f12c4bcc-a795-4d8c-b7da-0cc091b453ad.svg?v=1722836042'>"
      });
}

// Cases Slider 
if (window.matchMedia("(max-width: 767px)").matches) {
    $('.Custom_Cases_Slider .multi-column').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll:1,
        arrow:true,
         prevArrow:"<img class='a-left control-c customprev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay.svg?v=1722836043'>",
        nextArrow:"<img class='a-right control-c next customnext slick-next' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay_3x_f12c4bcc-a795-4d8c-b7da-0cc091b453ad.svg?v=1722836042'>"
      });
}


if (window.matchMedia("(max-width:1024px)").matches) {
    $('.custom_text_icon_slide ').slick({
        infinite: true,
        slidesToShow:1,
        slidesToScroll:1,
        arrow:false,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: false,
        nextArrow: false
        // prevArrow:"<img class='a-left control-c customprev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay.png?v=1721973354'>",
        // nextArrow:"<img class='a-right control-c next customnext slick-next' src='https://cdn.shopify.com/s/files/1/0738/1205/0184/files/Overlay_1.png?v=1721973353'>"
      });
}

